<template>
  <div class="mt15">
    <vue-tabs v-model="selPortfolio" direction="horizontal" @tab-change="getPortTabData">
      <v-tab
        :title="'Portfolio '+(index+1)"
        v-for="(alg, index) in portfolios"
        v-bind:key="'portfolio'+index"
      >
        <!-- <div class="row mt15">
          <div class="col-md-11"></div>
          <div class="col-md-1">
            <button class="btn btn-danger btn-sm" @click="removePort(index)">
              <i class="fa fa-trash"></i>
            </button>
          </div>
        </div> -->
        <!-- @removePortfolio="removePort" -->
        <portfolio
        @removePortfolio="removePort"
          :portData="alg"
          :portId="index"
          :priceVsIndexList="indexList"
          :companyList="companies"
        />
      </v-tab>
    </vue-tabs>
  </div>
  <!-- </card> -->
</template>
<script>
import http from "@/lib/http";
import "vue-multiselect/dist/vue-multiselect.min.css";
import { commonMixins } from "@/assets/mixins/common.js";
import portfolio from "./portfolio.vue";

export default {
  mounted() {},
  mixins: [commonMixins],
  props: ["portfolios"],
  components: { portfolio },
  created() {
    // console.log("portfolios", this.portfolios);
    this.getIndicesMaster();
  },
  data() {
    return {
      selPortfolio: "",
      companies: [],
      indexList: []
    };
  },
  methods: {
    getPricevscomp() {
      let _this = this;
      http.get("getCompanyMaster", {}, function(error, response) {
        _this.companies = response;
        console.log(_this.companies);
      });
    },
    getIndicesMaster() {
      let _this = this;
      http.get("getIndicesMaster", {}, function(error, response) {
        _this.indexList = response;
        console.log(_this.indexList);
        _this.getPricevscomp();
      });
    },
    getPortTabData(tabIndex, newTab, oldTab) {
      console.log(tabIndex, newTab, oldTab);
      this.selPortfolio = tabIndex;
    },
    removePort(obj) {
      let ind = obj.portId;
      var _this = this;
      console.log(_this.portfolios[ind]._id);
      var cnfm = confirm("Are you sure you want to delete?");
      if (cnfm) {
        http.post(
          "delete/SavePortfolios",
          { _id: _this.portfolios[ind]._id },
          function(error, response) {
            if (response.status === "success") {
              _this.$toastr.success("Portfolio deleted successfully!", {});
              _this.portfolios = _this.portfolios.splice(ind, 1);
            }
            // _this.portfolios = _this.portfolios.splice(ind, 1);
          }
        );
      }
    }
  },
  mounted() {},
  watch: {
    portfolios: function(value) {
      console.log("se");
    }
  }
};
</script>
<style>
form .col-md-3 {
  width: 40%;
}
.table th.column-sort {
  cursor: pointer;
}

.table td {
  padding: 5px 10px 5px 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/indices-data/portfolioList.vue